import Vue                                               from "vue";
import { mapGetters }                                    from "vuex";
import { ErrorLogService, GridUtil, PartDetailServices } from "@/services";
import { default as SuggestPartApplication }             from "@/components/PartDetail/Dialogs/SuggestPartApplication/SuggestPartApplication.vue";

export default Vue.extend({
    name: "ApplicationsTab",
    components: {
        SuggestPartApplication
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId"]),
    },

    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
        partId: {
            type: Number,
            default: 0,
        }
    },

    created() {
        this.columns = GridUtil.localizeColumnLabels(this.columns, this.getContentItem);
    },

    data: () => ({
        columns: [
            { key: "OemDescription", localizationKey: "OEM" },
            { key: "ModelSeries", localizationKey: "Series" },
            { key: "LotNumber", localizationKey: "Lot" },
            { key: "SerialNumber", localizationKey: "Serial" },
            { key: "PartDescription", localizationKey: "Description" },
        ],
        loadingApplications: false,
        haveSuccessfullyLoadedApplications: false,
        items: null,
        partApplicationMessageLocalizationKey: "PartApplicationMessage1",
        partApplications: [],
    }),

    methods: {
        async getPartApplications() {
            try {
                this.loadingApplications = true;

                const params = {
                    partId: this.partId,
                    oemPartCode: this.oemPartCode,
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                };
                const data = await PartDetailServices.getPartApplications(params);
                
                this.partApplicationMessageLocalizationKey =
                    data && data.Items && data.Items.length > 0 ? "PartApplicationMessage1" : "PartApplicationMessage2";

                this.partApplications =  data.Items;
                this.haveSuccessfullyLoadedApplications = true;
            } catch (err) {
                ErrorLogService.LogException(err);
            } finally {
                this.loadingApplications = false;
            }
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedApplications || !this.loadingApplications){
                this.getPartApplications();
            }   
        }
    },
});
